<style lang="scss" scoped>
.content-part-nav-item {
  margin-left: -80px;

  .cover-tips {
    display: block;
    font-size: 10px;
    text-align: center;
    width: calc(100% - 10px);
  }

  .cover-color {
    font-size: 10px;

  }

  .scope-header {
    display: flex;
  }

  .color-cell {
    display: flex;
    align-items: center;
    padding-top: 2px;
  }
}
</style>
<style lang="scss">
.content-part-nav-item {
  .item-bd {
    display: flex;
  }

  .placeholder,
  .image-item {
    width: 60px !important;
    height: 60px !important;

    .add-text {
      display: none;
    }

    .image-meta {
      font-size: 10px;
    }
  }
}
</style>


<template>
  <div class="content-part-nav-item">
    <CompDragList v-model="localValue" @onAddItem="handleAddNavItem" type="text" btnText="添加导航项" :show-title="true"
      title="导航项">
      <template slot="body" slot-scope="scope">
        <!-- 非沉浸式：显示图标设置 -->
        <div class="scope-header" v-if="immersiveSwitch !== 1">
          <div class="scope-header-item">
            <SpImagePicker v-model="localValue[scope.index].navdefaultIcon" size="small" text="" />
            <span class="cover-tips">默认图标</span>
          </div>
          <div class="scope-header-item">
            <SpImagePicker v-model="localValue[scope.index].navActiveIcon" size="small" text="" />
            <span class="cover-tips">选中图标</span>
          </div>
        </div>
        <div>
          <div @click="handleSetLink(scope.index)" class="scope-content">
            <el-button v-if="!localValue[scope.index].cusTom || !localValue[scope.index].cusTom.pages_template_id" type="text"
              size="mini">请选择分区模块</el-button>
            <p v-else>
              <el-button type="text" size="mini" style="display: inline;">【{{
                localValue[scope.index].cusTom.pages_template_id }}】{{ localValue[scope.index].cusTom.template_title
                }}</el-button>
              <el-button type="text" size="mini" style="display: inline;" class="el-icon-delete"
                @click.stop="handledelLink(scope.index)"></el-button>
            </p>
          </div>

          <!-- 导航项文本内容 -->
          <div class='color-cell' v-if="immersiveSwitch === 1" style="margin-top: 8px;">
            <span style="margin-right: 10px; font-size: 12px; min-width: 70px;">文本内容：</span>
            <el-input v-model='localValue[scope.index].navItemText' size="mini" placeholder="请输入导航项文本内容" style="flex: 1;"/>
          </div>

          <!-- 导航项名称 -->
          <div class='color-cell'>
            <span style="margin-right: 10px; font-size: 12px; min-width: 70px;">导航项名称：</span>
            <el-input v-model='localValue[scope.index].navItemName' size="mini" placeholder="请输入导航项名称" style="flex: 1;"/>
          </div>



          <!-- 沉浸式：颜色模式设置 -->
          <div class='color-cell' v-if="immersiveSwitch === 1" style="margin-top: 10px;">
            <span style="margin-right: 10px; font-size: 12px;">颜色模式：</span>
            <el-radio-group v-model='localValue[scope.index].colorMode' size="mini">
              <el-radio-button label="light">浅色</el-radio-button>
              <el-radio-button label="dark">深色</el-radio-button>
            </el-radio-group>
          </div>

          <!-- 沉浸式：文本颜色设置 -->
          <div class='color-cell' v-if="immersiveSwitch === 1" style="margin-top: 10px;">
            <div style="display: flex; align-items: center;">
              <span class="cover-color">文本选中颜色</span>
              <el-color-picker v-model='localValue[scope.index].textActiveColor' size="mini" />
            </div>
            <div style="display: flex; align-items: center;">
              <span class="cover-color">其他颜色</span>
              <el-color-picker v-model='localValue[scope.index].textDefaultColor' size="mini" />
            </div>
          </div>

          <!-- 沉浸式：滑动后文本颜色设置 -->
          <div class='color-cell' v-if="immersiveSwitch === 1" style="margin-top: 10px;">
            <div style="display: flex; align-items: center;">
              <span class="cover-color">滑动后选中颜色</span>
              <el-color-picker v-model='localValue[scope.index].textActiveColorSlider' size="mini" />
            </div>
            <div style="display: flex; align-items: center;">
              <span class="cover-color">滑动后未选中颜色</span>
              <el-color-picker v-model='localValue[scope.index].textDefaultColorSlider' size="mini" />
            </div>
          </div>

          <!-- 非沉浸式：原有颜色设置 -->
          <div class='color-cell' v-if="immersiveSwitch !== 1">
            <div>
              <el-color-picker v-model='localValue[scope.index].navActiveColor' size="mini" />
              <span class="cover-color">选中颜色</span>
            </div>
            <div>
              <el-color-picker v-model='localValue[scope.index].otherColor' size="mini" />
              <span class="cover-color">其它颜色</span>
            </div>
          </div>
        </div>

      </template>
    </CompDragList>
  </div>
</template>

<script>
import { cloneDeep, throttle } from 'lodash'
import CompDragList from '../../comps/comp-dragList'
import { gWgts } from '../../scene'
import { transformSelectTem, getWgts } from "../../utils"
export default {
  name: "nav-item",
  components: { CompDragList },
  props: {
    value: Array,
    // 组件唯一标识
    uuid: String,
    immersiveSwitch: Number
  },
  data() {
    return {
      //
      localValue: []
    }
  },
  methods: {
    handleAddNavItem() {
      this.localValue.push({
        navItemName: '',//导航项名称
        navItemText: '',//导航项文本内容
        navdefaultIcon: '',//导航项默认图标
        navActiveIcon: '',//导航项选中图标
        navdefaultColor: '',
        navActiveColor: '',
        otherColor: '',
        // 沉浸式模式下的新字段
        colorMode: 'light', // 颜色模式：light(浅色) / dark(深色)
        textActiveColor: '', // 文本选中颜色
        textDefaultColor: '', // 文本未选中颜色
        textActiveColorSlider: '', // 滑动后文本选中颜色
        textDefaultColorSlider: '', // 滑动后文本未选中颜色
        cusTom: null
      })
    },
    async handleSetLink(index) {
      const { scene = '1001' } = this.$route.query
      const { pages_template_id: tid = '' } = this.localValue[[index]].cusTom || {}
      let params = {
        multiple: false,
        data: tid ? [tid] : [],
        isContentpart: true
      }
      const { data } = await this.$picker.customWgt(params)
      const title = data[0].template_title
      const id = data[0].pages_template_id
      const widgets = getWgts(scene)
      const value = await transformSelectTem(data, widgets)
      this.$set(this.localValue[index], 'cusTom', ...value)
    },
    async handledelLink(index) {
      this.$set(this.localValue[index], 'cusTom', null)
    },
  },
  watch: {
    uuid: {
      handler(newVal, oldVal) {
        this.localValue = cloneDeep(this.value)
      },
      immediate: true,
      deep: true
    },
    localValue: {
      handler(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  }

}
</script>
